import React from 'react';
import { useTranslation } from 'react-i18next';

import { CalculationsMenu } from '../CalculationsMenu';
import { FavoritesMenuList } from './components/FavoritesMenuList';

/**
 * Краткое меню избранного
 */
export const Favorites = () => {
  const { t } = useTranslation(['DeliveryForm', 'Common']);

  return (
    <CalculationsMenu
      buttonLabel={t('DeliveryForm:Favorites')}
      linkLabel={t('DeliveryForm:GoToFavorites')}
      linkHref={t('Common:FavoritesLink')}
    >
      {(sectionId) => <FavoritesMenuList sectionId={sectionId} />}
    </CalculationsMenu>
  );
};
